import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import {
   Home,
   Accelerator,
   Startups,
   Investors,
   Mentors,
   Partners,
   About,
   Faq,
   Blog,
   SingleBlog,
   Error,
   SignIn
} from "./pages";

const AppRouter = () => {
   return (
      <Router>
         <Routes>
            <Route path="/users" element={<div>users</div>} />
            <Route path="/" element={<Home />} />
            <Route path="/accelerator" element={<Accelerator />} />
            <Route path="/startup" element={<Startups />} />
            <Route path="/investor" element={<Investors />} />
            <Route path="/mentor" element={<Mentors />} />
            <Route path="/boosterpartner" element={<Partners />} />
            <Route path="/about" element={<About />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:id" element={<SingleBlog />} />
            <Route path="/signup" element={<SignIn />} />
            <Route path="/signin" element={<SignIn />} />
            <Route path="*" element={<Error />} />
         </Routes>
      </Router>
   );
};

export default AppRouter;
